import { Component, Input } from '@angular/core';

@Component({
  selector: 'rai-face-icon',
  standalone: true,
  templateUrl: './rai-face.component.html',
  styleUrls: ['./rai-face.component.scss']
})
export class RaiFaceComponent {
  @Input() width: number | string = 24;
  @Input() height: number | string = 24;
  @Input() color: string = '#1a73e8';
}
